export class ColorRampFilter extends PIXI.Filter {

    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform sampler2D uRamp;

        void main() {
            vec4 pattern = texture2D(uSampler, vTextureCoord);
            vec4 ramp;
            if(pattern.a == 0.0) {
                ramp = texture2D(uRamp, vec2(1, 0));
            }
            else {
                ramp = texture2D(uRamp, vec2(max(max(pattern.r, pattern.b), pattern.g) / pattern.a, 0));
            }
            gl_FragColor = vec4(ramp.rgb * pattern.a, pattern.a);
        }
    `;

    constructor(pRamp: PIXI.Texture) {
        super(undefined, ColorRampFilter.FRAG);
        this.uniforms.uRamp = pRamp;
        this.padding = 0;
    }
}
